/**
 * @ComponentFor Avensia.Shop.Features.Cms.Blocks.ShortcutButtonBlock.ShortcutButtonBlock
 */
import React from "react";
import classnames from "classnames";
import * as styles from "./base.scss";
import { addStandardEvent } from "../../../TrackingInformation/CustomGa4EventService";
import { pushState } from "Shared/history";
const ShortcutButtonBlock = (props) => {
    const model = props.model;
    const sendToDataLayerAndRedirect = (eventType, link) => {
        addStandardEvent("Kampanjpuffar", "Kampanjpuff", "Click", eventType);
        if (!!link)
            pushState(link);
    };
    return (React.createElement("button", { className: classnames(styles.shortcutButton), onClick: () => sendToDataLayerAndRedirect(model.text, model.link), tabIndex: props.tabIndex },
        !!model.text && (React.createElement("label", { className: classnames(styles.text, styles.bodyMedium, {
                [styles.image]: !!model.isImage,
            }) }, model.text)),
        React.createElement("div", { className: classnames(styles.imageContainer, {
                [styles.image]: !!model.isImage,
            }) },
            !!model.image && model.isImage && (React.createElement("div", { style: { backgroundImage: "url(" + model.image + ")" } })),
            !!model.image && !model.isImage && (React.createElement("img", { className: classnames(styles.icon), src: model.image })))));
};
export default ShortcutButtonBlock;
